import { render, staticRenderFns } from "./ClientNavigation.vue?vue&type=template&id=395beaa0"
import script from "./ClientNavigation.vue?vue&type=script&lang=js"
export * from "./ClientNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports